import React from 'react';

export default () => (
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 452.64 443.86">
        <title>next-gen-releases</title>
        <polygon
            style={{ fill: 'none' }}
            points="92.54 427.19 95.94 323.42 225.9 347.24 190.52 410.52 149.01 443.86 92.54 427.19"
        />
        <polygon style={{ fill: 'none' }} points="95.94 323.42 44.65 274.37 0 359.49 22.32 390.1 95.94 323.42" />
        <polygon
            style={{ fill: 'none' }}
            points="226.46 347.11 356.42 323.29 430.04 389.98 452.36 359.36 407.71 274.25 356.42 323.29 359.82 427.06 303.35 443.73 261.84 410.39 226.46 347.11"
        />
        <polygon
            style={{ fill: 'none' }}
            points="368.23 89.05 361.86 163.39 411.1 241.06 407.71 274.25 419.4 159.65 325.35 29.89 225.35 0.13 127.01 30.02 32.96 159.78 44.65 274.37 41.26 241.18 90.5 163.52 84.13 89.18 90.5 163.52 224.54 257.42 361.86 163.39 368.23 89.05"
        />
        <path style={{ fill: 'none' }} d="M47.84,158.56,45.93,68.87Z" transform="translate(178.61 188.55)" />
        <polygon
            style={{ fill: '#236387' }}
            points="92.82 427.06 96.22 323.29 226.18 347.11 190.8 410.39 149.29 443.73 92.82 427.06"
        />
        <polygon style={{ fill: '#236387' }} points="96.22 323.29 44.92 274.25 0.28 359.36 22.6 389.98 96.22 323.29" />
        <polygon
            style={{ fill: '#27729c' }}
            points="226.74 346.98 356.7 323.17 430.31 389.85 452.64 359.23 407.99 274.12 356.7 323.17 360.1 426.93 303.62 443.6 262.12 410.26 226.74 346.98"
        />
        <polygon
            style={{ fill: '#409ccf' }}
            points="368.51 88.92 362.14 163.27 411.37 240.93 407.99 274.12 419.68 159.52 325.63 29.76 225.63 0 127.29 29.89 33.24 159.65 44.92 274.25 41.54 241.06 90.77 163.39 84.41 89.05 90.77 163.39 224.82 257.29 362.14 163.27 368.51 88.92"
        />
        <path style={{ fill: '#409ccf' }} d="M48.12,158.44,46.21,68.75Z" transform="translate(178.61 188.55)" />
        <polygon style={{ fill: '#1c5472' }} points="84.44 89.02 33.24 159.65 41.54 241 90.7 163.32 84.44 89.02" />
        <polygon
            style={{ fill: '#1c5472' }}
            points="356.7 323.12 226.74 346.98 224.82 257.29 361.86 163.39 411.3 240.85 407.99 274.12 356.7 323.12"
        />
        <polygon
            style={{ fill: '#19465f' }}
            points="96.22 323.27 226.56 347.13 224.82 257.29 90.71 163.33 41.54 241 44.92 274.26 96.22 323.27"
        />
        <polygon
            style={{ fill: '#28729c' }}
            points="368.51 88.92 419.68 159.52 411.32 240.92 361.94 163.47 368.51 88.92"
        />
        <polygon
            style={{ fill: '#69b1d9' }}
            points="368.51 88.92 361.86 163.39 224.82 257.29 225.63 0 325.63 29.76 368.51 88.92"
        />
    </svg>
);
